import { Success, useEnsureValue } from "@indietabletop/appkit";
import { useCallback } from "react";
import { client } from "../../client.ts";
import { database } from "../../database.ts";
import type { Gang } from "../../engine/Gang.ts";

export function useEnsureShareId(gang: Gang) {
  const createGangSnapshot = useCallback(async () => {
    const snapshot = await client.createSnapshot("spacegits", gang.data);

    if (!snapshot.isSuccess) {
      return snapshot.mapFailure((failure) => {
        if (failure.type === "NETWORK_ERROR") {
          return `Failed to share gang due to a network issue.`;
        }

        return `Failed to share. Please restart the app.`;
      });
    }

    // Save and return new snapshot value
    const { snapshotId } = snapshot.value;
    await database.gangs.setSnapshotId(gang, snapshotId);
    return new Success(snapshotId);
  }, [gang]);

  return useEnsureValue(gang.data.snapshotId, createGangSnapshot);
}
